import {Injectable, EventEmitter, Output} from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';

export interface IconSearch {
  name: string;
  icon: string;
}
@Injectable({providedIn: 'root'})
export class CustomTabsService {
  @Output() imageSrc = new EventEmitter();
  constructor(private http: HttpClient) {}
  postCustomTabs = body => this.http.post('/rest-api/v1/admin/events/custom-tab', body);
  getCustomTabsForEvent = event_id => this.http.get(`/rest-api/v3/events/${event_id}`);
  deleteCustomTab = customTabId => this.http.delete(`/rest-api/v1/admin/events/custom-tab/${customTabId}`);
  getCustomTab = customTabId => this.http.get(`/rest-api/v1/admin/events/custom-tab/${customTabId}`);
  updateCustomTab = (customTabId, body) => this.http.patch(`/rest-api/v1/admin/events/custom-tab/${customTabId}`, body);
  getIconsByName = name => this.http.get(`/rest-api/v1/admin/events/custom-tab/icons-list?search=${name}`);
  getIcons = (type?: string) => {
    let params = new HttpParams();
    if (type) {
      params = params.set('type', type);
    }
    return this.http.get(`/rest-api/v1/admin/events/custom-tab/icons-list`, {params: params});
  };
  deleteIcon = iconId => this.http.delete(`/rest-api/v1/admin/events/custom-tab/icon/${iconId}`);
  postIcon = body => this.http.post(`/rest-api/v1/admin/events/custom-tab/icon`, body);

  selectImg(view, icon) {
    if (icon.target.files && icon.target.files.length) {
      const file = icon.target.files[0];
      view.selectedFile = file;
    }
  }

  loadPreview(selectedFile, view) {
    const reader = new FileReader();
    reader.readAsDataURL(selectedFile);
    reader.onload = (e: any) => {
      view.imageSrc = e.target.result;
    };
  }
}
